const MicrosoftIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="800"
      width="1200"
      viewBox="-33.0981 -55.17375 286.8502 331.0425"
      className={className}
    >
      <path d="M104.868 104.868H0V0h104.868z" fill="#f35325" />
      <path d="M220.654 104.868H115.787V0h104.867z" fill="#81bc06" />
      <path d="M104.865 220.695H0V115.828h104.865z" fill="#05a6f0" />
      <path d="M220.654 220.695H115.787V115.828h104.867z" fill="#ffba08" />
    </svg>
  )
}

export default MicrosoftIcon
